module.exports = __webpack_public_path__ + "img/itx-file-type-odi.c229f8cb.svg";